import { Box, Container, createTheme, CssBaseline, Grid, ThemeProvider } from "@mui/material";
import React, { useEffect, useState } from "react";
import ReactGA from 'react-ga';
import { Route, Switch } from 'react-router-dom';
import AdminActions from "./components/admin/actions/AdminActions";
import SurveillanceHistory from "./components/admin/actions/SurveillanceHistory";
import Manage from "./components/admin/manage/Manage";
import ManualBuy from "./components/admin/manual-buy/ManualBuy";
import OpenTrades from "./components/admin/manual-buy/OpenTrades";
import NearTo52WHigh from "./components/admin/NearTo52WHigh";
import MarketBreadthAtlas from "./components/atlas/MarketBreadthAtlas";
import Dashboard from "./components/dashboard/Dashboard";
import { PublicDashboard } from "./components/dashboard/PublicDashboard";
import Profile from "./components/demat/Profile";
import FNOControlCentre from "./components/fno/FNOControlCentre";
import ButtonAppBar from "./components/layout/ButtonAppBar";
import { Logout } from "./components/login/Logout";
import PrivacyPolicy from "./components/login/PrivacyPolicy";
import Portfolio from "./components/portfolio/Portfolio";
import Signup from "./components/registration/Signup";
import { UserManagement } from "./components/admin/manage/UserManagement";
import FNOLogs from "./components/fno/FNOLogs";
import DhanTokenUpdate from "./components/demat/DhanTokenUpdate";
import FNOEntry from "./components/fno/FNOEntry";
import WatchList from "./components/watchlist/WatchList";
import PlaceSuperOrder from "./components/so/PlaceSuperOrder"

const theme = createTheme({
  components: {
    MuiDataGrid: {
      defaultProps: {
        density: 'compact',
      },
    }
  }
});

const TRACKING_ID = "UA-233530920-1"; // OUR_TRACKING_ID
ReactGA.initialize(TRACKING_ID);

function parseUser() {
  let parsedUser = {}
  let userStored = localStorage.getItem('user');
  if (userStored !== null && userStored !== undefined) {
    try {
      parsedUser = JSON.parse(userStored);
    } catch (e) {
    }
  }
  return parsedUser;
}

const App = (props) => {
  // Remove computedMatch from props
  const { computedMatch, ...restProps } = props;
  const [user, setUser] = useState(parseUser());

  useEffect(() => {
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, []);

  useEffect(() => {
    if (Object.keys(user)?.length === 0)
      return

    let expiryDate = new Date(user?.exp * 1000);
    let now = new Date();

    // After we added custom JWT to backend, for frontend we take role from JWT and add it in user
    // We store this user in localStorage
    // This role won't be present if customer's localStorage still has old Google token and old user
    // If user does not have role then assume that customer has old localStorage data and clear the localStorage
    if (!user?.role || now > expiryDate) {
      localStorage.removeItem('user')
      localStorage.removeItem('fno_selected_users_sell');
      localStorage.removeItem('fno_selected_users_buy');
      setUser({})
    }
  }, [user])

  return (
    <Box style={{ background: '#F1F4FD' }} {...restProps}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <ButtonAppBar user={user} setUser={setUser} />
        <Switch>
          <Route path='/' exact={true} component={() => <PublicDashboard user={user} setUser={setUser} />} />
          <Route path='/dashboard' component={() => <Dashboard user={user} whose={'system'} />} />

          <Box sx={{ m: 0.25 }}>
            <Container maxWidth={false} sx={{ width: '99%' }}>
              <Grid container rowSpacing={{ xs: 1, sm: 2, md: 2, xl: 2 }}
                columnSpacing={{ xs: 1, sm: 2, md: 2, xl: 2 }}
              >
                <Route path='/signup' component={() => <Signup />} />
                <Route path='/my-dashboard' component={() => <Dashboard user={user} whose={'self'} />} />
                <Route path='/demat-profile' component={() => <Profile user={user} />} />
                <Route path='/manual-trigger' component={() => <ManualBuy user={user} />} />
                <Route path='/user' component={() => <UserManagement user={user} />} />
                <Route path='/model-portfolio' component={Portfolio} />
              `  <Route path='/open-trades' component={() => <OpenTrades user={user} />} />
                <Route path='/near-52w-high' component={() => <NearTo52WHigh user={user} />} />
                <Route path='/manage' component={() => <Manage user={user} />} />
                <Route path='/admin-actions' component={() => <AdminActions user={user} />} />
                <Route path='/watchList' component={() => <WatchList user={user} />} />
                <Route path='/fnoControlCentre' component={() => <FNOControlCentre user={user} />} />
                <Route path='/fnoLogs' component={() => <FNOLogs user={user} />} />
                <Route path='/place-super-order' component={() => <PlaceSuperOrder user={user} />} />
                <Route path='/broker-profile' component={() => <DhanTokenUpdate user={user} />} />
                <Route path='/fnoEntry' component={() => <FNOEntry user={user} />} />
                <Route path='/privacy-policy' component={() => <PrivacyPolicy />} />
                <Route path='/atlas' component={MarketBreadthAtlas} />
                <Route path='/surveillance-history' component={() => <SurveillanceHistory user={user} />} />
                {/*<Route path='/contact-us' component={() => <ContactUs />} />*/}
                <Route path='/logout' component={() => <Logout />} />
              </Grid>
            </Container>
          </Box>
        </Switch>
      </ThemeProvider>
    </Box >
  );
};

export default App